import CategorySection from '../../components/categorySection/CategorySection'
import Hero from '../../components/hero/Hero'
import Review from '../../components/review/Review'
import Feature from '../../components/feature/Feature'

const Home = () => {
	return (
		<>
			<Hero />
			<CategorySection />
			<Review />
			<Feature />
		</>
	)
}

export default Home
